import React from 'react';

interface WidgetHeaderProps {
  children?: React.ReactNode;
}

const WidgetHeader: React.FC<WidgetHeaderProps> = ({ children }) => {
  return <div className="widget-header">{children}</div>;
};

export default WidgetHeader;
